import React from "react";

const Form = props => {
  return (
    <form onSubmit={props.loadWeather}>
      <input
        className="input-box"
        type="text"
        name="city"
        placeholder="Choose a City"
      />
      <input
        className="input-box"
        type="text"
        name="country"
        placeholder="Choose a Country"
      />
      <button className="button">Get Weather</button>
    </form>
  );
};

export default Form;
